import {certificateService, defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {efdocConstants, certboxConstants, sentConstants, uriConstants} from "../../constants";

export const efdocActions = {
  changeSearchInfo,
  //readcertboxList,
  readEfDocList,
  readOrgcertboxList,
  readcertboxReadingList,
  deletecertboxList,
  selectcertboxInfo,
  openReceiverBox,
  addReceiverInfo,
  getRecentReceiver,
  changeFileRow,
  getcertboxInfo,
  getPcrlInfo,
  getCrtfInfo,
  createCrtfSubmit,
  createCrtfReading,
  getWalletAddr,
  settingHistory,
  rejectcertbox,
  readingbox,
  getPdfString,
  initPdfFlag,
  getWalletName,
  resetWalletList,
  onClear,
  getFile,
  subcertboxDocPdf,
  showPwdPopup,
  receivecertbox
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 수신함 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: efdocConstants.SELECT_SEARCH_REQUEST,
      payload: info
    }
  }
}

/*********
 공인전자문서 리스트 조회
 **********/

function readEfDocList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_EFDOC_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: efdocConstants.EFDOC_REQUEST
    }
  }
  function success(response) {
    return {
      type: efdocConstants.EFDOC_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: efdocConstants.EFDOC_FAILURE,
      response
    }
  }
}

/*********
 수신함 원본 리스트 조회
 **********/

function readOrgcertboxList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_INBOX_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.CERTBOX_ORG_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.CERTBOX_ORG_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.CERTBOX_ORG_FAILURE,
      response
    }
  }
}

/*********
 수신함 1회열람 리스트 조회
 **********/

function readcertboxReadingList(onetmPrslCntnTocken) {
  return async dispatch => {
    dispatch(request())
    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_READING_LIST + onetmPrslCntnTocken
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.CERTBOX_READING_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.CERTBOX_READING_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.CERTBOX_READING_FAILURE,
      response
    }
  }
}

/*********
 수신함 발급완료건 삭제
 **********/

function deletecertboxList(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.SET_INBOX_INFO,
      params: params,
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.DELETE_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.DELETE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.DELETE_FAILURE,
      response
    }
  }
}

/***********
 수신함 증명서 상세 선택
 ************/
function selectcertboxInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: certboxConstants.SELECT_REQUEST,
      payload: info
    }
  }
}

/***********
 증명서 제출 수신자 SELECT 팝업 오픈
 ************/
function openReceiverBox(target) {
  return async dispatch => {
    dispatch(request(target))
  }
  function request() {
    return {
      type: certboxConstants.OPEN_RECEIVER_REQUEST,
      payload: target
    }
  }
}

/***********
 증명서 제출 수신자 추가
 ************/
function addReceiverInfo(receiver) {
  return async dispatch => {
    dispatch(request(receiver))
  }
  function request() {
    return {
      type: certboxConstants.ADD_RECEIVER_REQUEST,
      payload: receiver
    }
  }
}

/***********
 증명서 제출 전자지갑 리스트 초기화
 ************/
function resetWalletList() {
  return async dispatch => {
    dispatch(request())
  }
  function request() {
    return {
      type: certboxConstants.RESET_RECEIVER,
      payload: null
    }
  }
}

/*********
 최근 보낸 주소 조회
 **********/

function getRecentReceiver(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_RECENT_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.SELECT_RECENT_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.SELECT_RECENT_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.SELECT_RECENT_FAILURE,
      response
    }
  }
}

/***********
 증명서 제출 첨부문서 row 최신화
 ************/
function changeFileRow(fileList) {
  return async dispatch => {
    dispatch(request(fileList))
  }

  function request() {
    return {
      type: certboxConstants.CHANGE_FILE_REQUEST,
      payload: fileList
    }
  }
}

/*********
 수신함 증명서 상세조회
 **********/

function getcertboxInfo(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_INBOX_INFO + "/" + crtSeq
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.DETAIL_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.DETAIL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.DETAIL_FAILURE,
      response
    }
  }
}

/*********
 수신함 구매확인서 조회
 **********/

function getPcrlInfo(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_PRCL_INFO + "/" + crtSeq
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.PCRL_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.PCRL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.PCRL_FAILURE,
      response
    }
  }
}

/*********
 수신함 간접수출실적증명서 조회
 **********/

function getCrtfInfo(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CRTF_INFO + "/" + crtSeq
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.CRTF_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.CRTF_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.CRTF_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서 제출
 **********/
function createCrtfSubmit(params) {
  return async dispatch => {
    dispatch(request())
    certificateService.createCrtfSubmit(params)
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.SUBMIT_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.SUBMIT_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.SUBMIT_FAILURE,
      response
    }
  }
}


/*********
 수신함 증명서 1회열람
 **********/
function createCrtfReading(params) {
  return async dispatch => {
    dispatch(request())
    certificateService.createCrtfReading(params)
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.READING_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.READING_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.READING_FAILURE,
      response
    }
  }
}


/*********
 수신함 증명서 반려
 **********/
function rejectcertbox(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.REJECT_CERTIFICATE,
      params: params
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }
  function request() {
    return {
      type: certboxConstants.REJECT_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.REJECT_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.REJECT_FAILURE,
      response
    }
  }
}


/*********
 수신함 1회 열람 확인
 **********/
function readingbox(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.READING_COMPLETION,
      params: params
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }
  function request() {
    return {
      type: certboxConstants.READING_COMPLETION_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.READING_COMPLETION_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.READING_COMPLETION_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서제출 전자지갑주소검색
 **********/
function getWalletAddr(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_WALLET_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.WALLET_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.WALLET_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.WALLET_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서제출 전자지갑이름검색
 **********/
function getWalletName(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_WALLET_LIST + "/" + params
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.WALLET_NAME_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.WALLET_NAME_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.WALLET_NAME_FAILURE,
      response
    }
  }
}

/***********
 증명서 수신함 리스트 히스토리관리
 ************/
function settingHistory(history) {
  return async dispatch => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: efdocConstants.EFDOC_HISTORY,
      payload: history
    }
  }
}

/***********
 증명서 PDF BASE64STRING 조회
 ************/
function getPdfString(fileId) {
  return async dispatch => {
    dispatch(request(fileId))

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_PDF_INFO + "/" + fileId
      // endPoint: "http://192.168.0.9:8080/portal/pdf/107"
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.PDF_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.PDF_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.PDF_FAILURE,
      response
    }
  }
}

/***********
 PDF 호출 init 처리
 ************/
function initPdfFlag() {
  return async dispatch => {
    dispatch(request())
  }

  function request() {
    return {
      type: certboxConstants.INIT_FLAG_REQUEST,
    }
  }
}

/***********
 상태관련 state 초기화
 ************/
function onClear() {
  return async dispatch => {
    dispatch(request())
  }

  function request() {
    return {
      type: certboxConstants.CLEAR_REQUEST,
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

/***********
 증명서 첨부파일 다운로드
 ************/
function getFile(fileId) {
  return async dispatch => {
    dispatch(request(fileId))

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_FILE + "/" + fileId
      // endPoint: "http://192.168.0.9:8080/portal/pdf/107"
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: certboxConstants.FILE_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.FILE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.FILE_FAILURE,
      response
    }
  }
}

/*********
 수신함 PDF 발급요청
 **********/

function subcertboxDocPdf(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'post',
      endPoint: uriConstants.API_URI + uriConstants.SUB_SENT_DOC_PDF,
      params: 'crtSeq='+ crtSeq
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: certboxConstants.SUB_SENT_DOC_PDF_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.SUB_SENT_DOC_PDF_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.SUB_SENT_DOC_PDF_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서 수취완료
 **********/
function receivecertbox(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.RECEIVE_CERTIFICATE,
      params: params
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }
  function request() {
    return {
      type: certboxConstants.RECEIVE_REQUEST
    }
  }
  function success(response) {
    return {
      type: certboxConstants.RECEIVE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certboxConstants.RECEIVE_FAILURE,
      response
    }
  }
}


/*********
 수신함 1회 열람 열람버튼 클릭시 비번확인
 **********/
function showPwdPopup(isShow, certbox) {
	return {
		type: certboxConstants.SHOW_PWD_POPUP,
		isShow: isShow,
		certbox: certbox,
	}
}